import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { advancedSearchQueryKeyFactory } from "app/pages/sales-intelligence/pages/advanced-search/query/queryKeyFactory";

const useInvalidateLeadsSearchQueries = () => {
    const queryClient = useQueryClient();

    return useCallback(() => {
        return queryClient.invalidateQueries({
            queryKey: advancedSearchQueryKeyFactory.tableData(),
            refetchType: "all",
        });
    }, [queryClient]);
};

export default useInvalidateLeadsSearchQueries;
